export const MENU_Z_INDEX = 11; // above frozen headers; if used in frozen headers, set menuPortalTarget to document.body
export const REMOVE_Z_INDEX = 12;
export const INDICATORS_Z_INDEX = 12;
